// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__1aduc","Body":"Body__1FCgX","Component":"Component__HYRVa","Button":"Button__1wud2","Rounded":"Rounded__MnLg3"};


//////////////////
// WEBPACK FOOTER
// ./routes/Settings/style.scss
// module id = A+Mm
// module chunks = 0